import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Alert } from 'reactstrap';
import { LongTermScheduleDayCancelOptions } from './LongTermSchedule';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';

export default class CancelDateInformation extends React.Component {
    getNextOpenDayInformation = (reschedulingEffect) => {
        return (
            <>
                The work will be rescheduled to{' '}
                {moment(reschedulingEffect.nextOpenDay).format(
                    MomentDateFormat.WeekDayNameAndDate
                )}
                .{' '}
                {reschedulingEffect.scheduleEndDateIfOpenDayChosen &&
                    !moment(
                        reschedulingEffect.scheduleEndDateIfOpenDayChosen
                    ).isSame(reschedulingEffect.nextOpenDay, 'day') && (
                        <span>
                            The new end date of the schedule will be{' '}
                            {moment(
                                reschedulingEffect.scheduleEndDateIfOpenDayChosen
                            ).format(MomentDateFormat.WeekDayNameAndDate)}
                            .
                        </span>
                    )}
                {reschedulingEffect.scheduleEndDateIfOpenDayChosen &&
                    moment(
                        reschedulingEffect.scheduleEndDateIfOpenDayChosen
                    ).isSame(reschedulingEffect.nextOpenDay, 'day') && (
                        <span>
                            The long-term schedule will also be updated to end
                            on this date.
                        </span>
                    )}
            </>
        );
    };

    getNextWorkingDayInformation = (reschedulingEffect) => {
        return (
            <>
                The work will be rescheduled to{' '}
                {moment(reschedulingEffect.nextWorkingDay).format(
                    MomentDateFormat.WeekDayNameAndDate
                )}
                . The long-term schedule will also be updated to end on this
                date.
            </>
        );
    };

    isSupportedCancelOption = (cancelRequest) =>
        cancelRequest.longTermScheduleDayCancelOptionId ==
            LongTermScheduleDayCancelOptions.NextOpenDay ||
        cancelRequest.longTermScheduleDayCancelOptionId ==
            LongTermScheduleDayCancelOptions.NextWorkingDay;

    render() {
        const { reschedulingEffect, cancelRequest } = this.props;

        if (
            !reschedulingEffect ||
            !cancelRequest ||
            !this.isSupportedCancelOption(cancelRequest)
        ) {
            return null;
        }

        return (
            <Alert color="info" fade={false} className="mt-1">
                <div className="float-left">
                    <FontAwesomeIcon icon={faInfoCircle} />
                </div>
                <div>
                    {cancelRequest.longTermScheduleDayCancelOptionId ==
                        LongTermScheduleDayCancelOptions.NextOpenDay &&
                        this.getNextOpenDayInformation(reschedulingEffect)}

                    {cancelRequest.longTermScheduleDayCancelOptionId ==
                        LongTermScheduleDayCancelOptions.NextWorkingDay &&
                        this.getNextWorkingDayInformation(reschedulingEffect)}
                </div>
            </Alert>
        );
    }
}
